import React, { Component } from 'react';
import SignatureForm from "../Components/SignatureForm";
import {SignatureABRM} from "../Components/SignatureABRM";

class ABRMSignatureContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: "Jan Kowalski",
            mail: "j.kowalski@pzbad.pl",
            jobTitle: "Stażysta",
            phone: "",
            cellphone: "111 111 111"
        };
    }

    setStateFromProps(e){
        const name = e.target.name;
        const value = e.target.value;
        this.setState({
            [name]: value
        });
    }
    handleClick = ev => {
        const copyBoxElement =this.copyBoxRef.current;
        copyBoxElement.contentEditable = true;
        copyBoxElement.focus();
        document.execCommand('selectAll');
        document.execCommand('copy');
        copyBoxElement.contentEditable = false;
        getSelection().empty();
    };
    copyBoxRef = React.createRef();

    render() {
        return (
            <div className="container">
                <div className="card mb-3 mt-3 shadow-sm">
                    <div className="card-header">
                        <div style={{display: "flex",
                            flexDirection: 'row',
                            flexWrap: 'nowrap',
                            justifyContent: 'space-between',
                            alignContent: 'flex-start',
                            alignItems: 'flex-start'}}>
                            <div style={{order: 0, flex: '0 1 auto', alignSelf: 'auto'}}><h1>Generator Stopki</h1></div>

                            <div style={{order: 0, flex: '0 1 auto', alignSelf: 'auto'}}><button className='btn btn-outline-dark' onClick={this.handleClick.bind(this)}>Kopiuj</button></div>
                        </div>
                    </div>
                    <div className="card-body">
                        <div className="row">
                            <div className="col-12 col-sm-4">
                                <SignatureForm stateValue={this.state} setStateFromProps={this.setStateFromProps.bind(this)} initialValues={this.state}/>
                            </div>
                            <div className="col-12 col-sm-8">
                                <SignatureABRM state={this.state} copyBoxRef={this.copyBoxRef}/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ABRMSignatureContainer;



// WEBPACK FOOTER //
// src/Container/ABRMSignatureContainer.js